import PropTypes from 'prop-types'
import { IconButton, Stack, SvgIcon, Tooltip, Typography } from '@mui/material'
import { Box } from '@mui/system'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import Avatar from '../avatar/avatar.component'
import { AVATAR_SIZE, AVATAR_TYPES } from '../avatar/avatar.constants'

import { styles } from './radio-button.styles'

const RadioButtonLabel = ({
  avatar,
  icon,
  label,
  largeLabel,
  helperText,
  disabled,
  description,
  checked,
  warning,
}) => {
  const hasStartAdornment = !largeLabel && !helperText && !description
  const isCard = label && helperText && description

  return (
    <Stack sx={styles.boxLabel} direction="row" spacing={2}>
      {hasStartAdornment && avatar && (
        <Avatar
          avatarType={AVATAR_TYPES.SINGLE_AVATAR}
          size={AVATAR_SIZE.MEDIUM}
          item={{ ...avatar.item }}
        />
      )}
      {hasStartAdornment && icon && !avatar && <SvgIcon sx={styles.icon} component={icon} />}
      <Box sx={[styles.boxText, isCard && styles.cardBox]}>
        {(label || largeLabel) && (
          <Box
            data-text={label || largeLabel}
            sx={[styles.labelWrapper, styles.weightChange, warning && styles.weightChangeWarning]}
          >
            <Typography
              sx={[styles.label, isCard && styles.cardLabel, checked && styles.labelChecked]}
              component="div"
            >
              {label || largeLabel}
              {warning && (
                <Tooltip title={<Typography typography="header5">{warning}</Typography>}>
                  <IconButton sx={styles.toolTipButton} size="small" disableRipple>
                    <InfoOutlinedIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Typography>
          </Box>
        )}

        {helperText && (
          <Typography
            sx={[styles.helperText, checked && !isCard && !disabled && styles.helperTextChecked]}
          >
            {helperText}
          </Typography>
        )}
        {description && <Typography sx={styles.description}>{description}</Typography>}
      </Box>
    </Stack>
  )
}

RadioButtonLabel.propTypes = {
  label: PropTypes.string,
  largeLabel: PropTypes.string,
  helperText: PropTypes.string,
  description: PropTypes.string,
  warning: PropTypes.string,
  avatar: PropTypes.shape({
    item: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    }).isRequired,
  }),
  icon: PropTypes.elementType,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
}

export default RadioButtonLabel
